import { createSelector } from 'reselect'

export const getSavedSearchBtnEnabled = createSelector(
  (state) => state && state.ads && state.ads.list && state.ads.list.isSavedAdsButtonEnabled,
  isSavedAdsButtonEnabled => isSavedAdsButtonEnabled
)
